import { Service } from '@angular/core';

const counters = new Map<string, number>();

@Service()
export class UniqueId {
  private static infix = `bui${typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID().slice(0, 8) : Date.now().toString(36)}`;

  /**
   * Generates a unique ID with a specific prefix.
   * @param prefix Prefix to add to the ID.
   * @param randomize Add a randomized infix string.
   */
  getId(prefix: string, randomize = false): string {
    let current = counters.get(prefix) ?? 0;

    current++;
    counters.set(prefix, current);

    return `${prefix}${randomize ? UniqueId.infix + '-' : ''}${current}`;
  }
}
